/* gifsicle-wasm builds run() as `new Promise(async (resolve, reject) => {…})`:
 * an exception INSIDE the async executor (postMessage to the worker failed with
 * DataCloneError «Data cannot be cloned, out of memory» — the whole buffer is
 * copied, and the tab's heap ran out) rejects the async function's own promise,
 * which nobody holds; the promise we got never settles: progress hangs and an
 * unhandledrejection with no address lands in Sentry (TIMBRICA-FRONTEND-J2 on
 * /gif-compressor 07.09.2026, again on /gif-trim 19.09). While a run is in
 * flight, such a rejection is caught here and turned into OUR typed refusal —
 * handleError then talks about memory, not «something broke».
 *
 * One door for /gif-compressor, /gif-trim and /gif-speed:
 *   window.__gifsicleGuard(gifsicle.run({...})) → Promise
 */
(function () {
    'use strict';
    function guard(run) {
        return new Promise(function (resolve, reject) {
            var settled = false;
            function finish(fn, v) {
                if (settled) return;
                settled = true;
                window.removeEventListener('unhandledrejection', onRejection);
                fn(v);
            }
            function onRejection(ev) {
                var r = ev && ev.reason, msg = String((r && r.message) || r || '');
                var isHandoff = (r && r.name === 'DataCloneError') || /cannot be cloned|out of memory/i.test(msg);
                if (!isHandoff || settled) return;
                try { ev.preventDefault(); } catch (_) {}
                var err = new Error('gifsicle worker handoff failed: ' + msg);
                err.code = 'OUT_OF_MEMORY';
                finish(reject, err);
            }
            window.addEventListener('unhandledrejection', onRejection);
            Promise.resolve(run).then(function (v) { finish(resolve, v); }, function (e) { finish(reject, e); });
        });
    }
    window.__gifsicleGuard = guard;
})();
